var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.role === '1')?_c('section',[_c('p',[_vm._v("Документооборот")])]):_c('section',[_c('p',{staticClass:"title"},[_vm._v("Данный функционал доступен только Администратору")])])
}
var staticRenderFns = []

export { render, staticRenderFns }